import AccessDetailTable from './AccessDetailTable';

export default AccessDetailTable;
